import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {API_URL, HttpService} from '../../../core/public-api';
import {HttpEvent} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FileService {

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    private http: HttpService
  ) {
  }

  // postFile<T>(endpoint: string, fileKey: string, file: File): Observable<T> {
  // 	const formData: FormData = new FormData();
  // 	formData.append(fileKey, file, file.name);
  // 	return this.http.doHttpPost<T>(endpoint, formData)
  // }

  postFile<T>(endpoint: string, fileKey: string, files: File[]): Observable<HttpEvent<T>> {
    const formData: FormData = new FormData();
    files.forEach(file => {
      formData.append(fileKey, file, file.name);
    })

    return this.http.doHttpPostWithEvents<T>(endpoint, formData, {
      observe: 'events',
      reportProgress: true,
    })
  }

  getDownLoadFileLink(fileId: number) {
    return `/file/download/${fileId}`
  }

  getDeleteFileLink(fileId: number) {
    return `/file/delete/${fileId}`
  }

  getUploadFileLink(type: string, id: number) {
    return `/file/for-${type}/${id}/upload`
  }

  getListFilesLink(type: string, id: number) {
    return `/file/for-${type}/${id}/list`
  }

  getIcon(ext: string) {
    if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif' || ext === 'webp') {
      return 'photo';
    } else if (ext === 'pdf' || ext === 'doc' || ext === 'docx' || ext === 'txt') {
      return 'insert_drive_file';
    } else if (ext === 'zip' || ext === 'rar') {
      return 'archive';
    } else {
      return 'attach_file';
    }
  }

  getImageThumbNail(fileId: number) {
    return this.apiUrl + this.getDownLoadFileLink(fileId) + '/tiny'
  }

  getImageOriginal(fileId: number) {
    return this.getDownLoadFileLink(fileId) + '/original'
  }

  getDownLoadFileLinkForQuote(quoteCode: string, fileId: number) {
    return `/file/for-quote/by-code/${quoteCode}/download/${fileId}`
  }

  getListFilesLinkForQuote(quoteCode: string){
    return `/file/for-quote/by-code/${quoteCode}/list`
  }

  getUploadFileLinkForQuote(quoteCode: string) {
    return `/file/for-quote/by-code/${quoteCode}/upload`
  }


}
